import { Component, ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { HttpService } from "../../service/http.service";
import { GeneralSupplier } from 'src/app/general-supplier';
import { GeneralSupplierPaymentType } from 'src/app/general-supplier-payment-type';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GeneralSupplierUnpaidInvoiceForm } from "../../form-template/general-supplier-unpaid-invoice-form";
import * as moment from 'moment';
import { GeneralSupplierUnpaidInvoice } from 'src/app/general-supplier-unpaid-invoice';
import Decimal from 'decimal.js';
import { Moment } from 'moment';
import { Currency } from 'src/app/currency';
import { ToastMessageService } from '../../toast-message.service';
import { ApiError } from 'src/app/api-error';
import { UserService } from 'src/app/service/user.service';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-create-unpaid-invoice',
  templateUrl: './create-unpaid-invoice.component.html',
  styleUrl: './create-unpaid-invoice.component.css'
})
export class CreateUnpaidInvoiceComponent {
  suppliers: GeneralSupplier[] = [];
  paymentTypes: GeneralSupplierPaymentType[] = [];
  selectedFile: File | null = null;
  @ViewChild("fileUploader") fileUploader: FileUpload | null = null;
  invoiceForm: FormGroup<GeneralSupplierUnpaidInvoiceForm>;

  isSupplierDialogVisible: boolean = false;
  supplierForm: FormGroup;

  isCreatingInvoice = false;
  isInvoiceValidator: boolean = false;
  canAddInvoice: boolean = false;
    topMenuItems: MenuItem[] = [];

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    public toastService: ToastMessageService,
    public userService: UserService
  ){
    this.httpService.getGeneralSuppliers().subscribe(res => {
      this.suppliers = res;
    });
    this.httpService.getGeneralSupplierPaymentTypes().subscribe(res => {
      this.paymentTypes = res;
      this.invoiceForm.controls.paymentType.setValue(this.paymentTypes.at(1)!);
    });
    this.isInvoiceValidator = userService.hasAnyRole(["superadmin", "general_invoice_validator"]);
    if(userService.isNot("accountant")){
      this.canAddInvoice = true;
    }
    this.topMenuItems = [
      { label: "Invoices", routerLink: ["/management/general-supplier-invoice/invoices"] },
      { label: "Unpaid invoices", routerLink: ["/management/general-supplier-invoice/unpaid-invoices"], visible: this.canAddInvoice},
      { label: "Add paid invoice", routerLink: ["/management/general-supplier-invoice/create-paid-invoice"], visible: this.canAddInvoice}
    ];

    this.invoiceForm = builder.group<GeneralSupplierUnpaidInvoiceForm>({
      supplier: new FormControl(),
      amount: new FormControl(),
      date: new FormControl(),
      file: null,
      comment: new FormControl(),
      paymentType: new FormControl(null),
      isValidated: new FormControl(this.isInvoiceValidator?true:false),
      invoiceNumber: new FormControl(null)
    });
    this.supplierForm = builder.group({
      name: new FormControl<string | null>(null, Validators.required)
    });
  }

  submitSupplier(){
    let supplier: GeneralSupplier = {
      name: this.supplierForm.value.name,
      id: null
    };
    this.httpService.postGeneralSupplier(supplier).subscribe(() => {
      this.invoiceForm.controls.supplier.setValue(null);
      this.httpService.getGeneralSuppliers().subscribe(res => {
        this.suppliers = res;
        this.supplierForm.reset();
        this.isSupplierDialogVisible = false;
      });
    });
  }

  activateSupplierDialog(){
    this.isSupplierDialogVisible = true;
  }

  onFileSelect(files: File[]){
    if(files.length > 0){
      this.selectedFile = files[0];
    }
  }
  clearSelectedFile(){
    this.fileUploader?.clear();
    this.selectedFile = null;
  }

  submit(){
    if(this.invoiceForm.value.date){
      let date = moment(this.invoiceForm.value.date);

      let invoiceNumber = null;
      if(this.invoiceForm.value.invoiceNumber && this.invoiceForm.value.invoiceNumber.length >0
      ){
        invoiceNumber = this.invoiceForm.value.invoiceNumber;
      }

      let comment = null;
      if(this.invoiceForm.value.comment && this.invoiceForm.value.comment.length > 0){
        comment = this.invoiceForm.value.comment.trim();
      }

      let invoice : GeneralSupplierUnpaidInvoice = {
        id: null,
        date: date,
        createdBy: null,
        amount: new Decimal(this.invoiceForm.value.amount!),
        currency: new Currency(1, "Euro", "EUR", "€"),
        type: this.invoiceForm.value.paymentType!,
        supplier: this.invoiceForm.value.supplier!,
        created: null,
        fileName: null,
        isValidated: this.invoiceForm.value.isValidated!,
        validatedBy: null,
        invoiceNumber: invoiceNumber,
        isPaid: false,
        comment: comment
      };

      this.isCreatingInvoice = true;
      this.httpService.postGeneralSupplierUnpaidInvoice(invoice, this.selectedFile!).subscribe(() => {
        console.log("success");
        this.toastService.addSuccess("Success", "You added new invoice");
        this.invoiceForm.reset();
        this.clearSelectedFile();
        this.isCreatingInvoice = false;
      }, error => {
        let apiError = new ApiError(error);
        this.toastService.addApiError(apiError);
        this.isCreatingInvoice = false;
      });
    } else {
      console.error("date is missing");
    }
  }
}